var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#E35B5B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.26795C17.3333 9.03775 17.3333 10.9623 16 11.7321L8.5 16.0622C7.16666 16.832 5.5 15.8697 5.5 14.3301L5.5 5.66987C5.5 4.13027 7.16667 3.16802 8.5 3.93782L16 8.26795Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoReview);
export default ForwardRef;